import { useTranslation } from "react-i18next";
import Download from "../../../../components/Files/downloadDocuments";
import moment from "moment";
import DeleteDocument from "../DeleteDocument";
import FileService from "../../../../services/FileService";

export function OtherDocumentLine({ docs, interviewId, deleteCallBack, disabled }) {
  const { t } = useTranslation();

  function downloadDocument(documentId) {
    FileService.DownloadFileBase64(`vitae/file/${documentId}`, true);
  }
  
  return (
    <>
      {docs &&
        docs.map((document) => (
          <tr>
            <td
              className="languages"
              onClick={() => downloadDocument(document.id)}
            >
              {document.language}
            </td>
            <td
              className="description"
              onClick={() => downloadDocument(document.id)}
            >
              {document.description}
            </td>
            <td
              className="updated-date"
              onClick={() => downloadDocument(document.id)}
            >
              {moment(document.updateAt).format("DD-MM-YYYY")}
            </td>
            {!disabled && (
            <td className="actions d-flex">
              <Download
                url={`vitae/file/${document.id}`}
                fileName={document.description}
              />
              <DeleteDocument
                documentId={document.id}
                interviewId={interviewId}
                deleteCallBack={deleteCallBack}
              />
            </td>
            )}
          </tr>
        ))}
      {(!docs || (docs && docs.length === 0)) && (
        <tr>
          <td colSpan="4" className="text-center">
            {t("No files added")}
          </td>
        </tr>
      )}
    </>
  );
}
